import { TableHeader } from '@common/types/common';
import { UserList } from '@common/types/user';

type MemberHeaderFields = UserList & { concatenated_name: string };

export const memberTableHeaders: TableHeader<MemberHeaderFields>[] = [
    {
        id: 'concatenated_name',
        label: 'Name',
    },
    {
        id: 'email',
        label: 'Email',
    },
    {
        id: 'company_name',
        label: 'Company',
    },
];

export const createMailchimpAudienceDialogHeaders: TableHeader<MemberHeaderFields>[] = [
    {
        id: 'concatenated_name',
        label: 'Name',
        width: '50%',
    },
    {
        id: 'email',
        label: 'Company & Email',
        sortable: false,
    },
];

export const getMemberOrderingFields = (sort: string | null | undefined): string[] | undefined => {
    if (!sort) {
        return undefined;
    }

    const isDescending = sort.startsWith('-');
    const field = isDescending ? sort.slice(1) : sort;

    if (field === 'name') {
        const direction = isDescending ? '-' : '';
        return [`${direction}concatenated_name`];
    }

    return [sort];
};
